// extracted by mini-css-extract-plugin
export default {"backdrop":"Loader_backdrop__ERdwy","loadtext":"Loader_loadtext__PRt7F","loadimg":"Loader_loadimg__rD47l"};